import { LicensingContext, SessionContext, ViamapPersistenceLayer } from "@viamap/viamap2-common";
import { Product } from "@viamap/viamap2-common/dist/managers/Types";
import { actionInitializeLicenseManager } from "@viamap/viamap2-common";
import { FormControl } from "react-bootstrap";
import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassInputControl, GlassInputGroup, GlassTextInputTransformer } from "./GlassInput";
import { GlassButton } from "./GlassButtons";
import { useState, useContext, useEffect } from "react";
import { ManagedWindow } from "src/WindowManager/WindowState";
import { MapitStateActionType, MapitStateContext } from "src/states/MapitState";
import { ApplicationStateContext } from "src/states/ApplicationState";

export const SimulateOtherUserDialog = (props: { managedWindow: ManagedWindow, onClose: () => void }) => {
   const [userEmail, setUserEmail] = useState<string>("");
   const { dispatch: licencingDispatch } = useContext(LicensingContext);
   const { dispatch: mapitStateDispatch } = useContext(MapitStateContext)
   const { hasAccessToFeature } = useContext(ApplicationStateContext);

   function actionSimulateUser() {
      try {
         let userRef = userEmail;
         let customerRef = ViamapPersistenceLayer.extractCustomerRef(userEmail) || "unknown";
         licencingDispatch(actionInitializeLicenseManager(Product.Mapit, customerRef, userRef));
         mapitStateDispatch({ type: MapitStateActionType.InitializeStandardLayers, payload: { hasAccessToFeatureFunction: hasAccessToFeature } });
         alert("Simulerer nu access rights for bruger " + userEmail);
      } catch (err: any) {
         alert("Simulering fejlede. " + (err.message || err))
      }
      props.onClose();
   }

   return (
      <AdvancedDragModal onClose={props.onClose}
         window={props.managedWindow}
         title={"Simulate other user login"}
      >

         <ADModalBody>
            <GlassInputGroup
               autoFocus={0}
               onSubmit={() => {
                  actionSimulateUser();
               }}
               onEscape={() => {
                  props.onClose();
               }}
            >
               <GlassTextInputTransformer label={"User Email"}>
                  <GlassInputControl>
                     <FormControl type="text" disabled={false} value={userEmail} placeholder={"email"} onChange={(e) => { setUserEmail(e.target.value) }} />
                  </GlassInputControl>
               </GlassTextInputTransformer>
            </GlassInputGroup>
         </ADModalBody>
         <ADModalFooter>
            <GlassButton onClick={() => {
               actionSimulateUser();
            }}>Do it</GlassButton>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}